<template>
  <div v-loading="loading">
    <div v-if="hasMeasurement">
      <div style="display:flex;flex-direction: row;justify-content: right;align-items: center;">
        
        <el-select size="mini" v-model="measurementType" :placeholder="$t('trend.measurementType')" clearable @change="init()" style="  z-index: 999;
        right: 120px;
        top: 5px;
        margin-right:10px;
        float: right;">
          <el-option v-for="item in this.measurementTypes" :key="item" :label="$t('common.' + item)" :value="item">
          </el-option>
        </el-select>
        
        <el-date-picker size="mini" v-model="dateRange" type="datetimerange" style="
        z-index: 999;
        right: 120px;
        top: 5px;
        float: right;
        " :picker-options="pickerOptions" :format="pickerOptions.format" range-separator="-"
        start-placeholder="Start date" end-placeholder="End date" @change="init()"></el-date-picker>
      </div>

      <el-row>
        <el-col class="apexChartClass" :span="24">
          <TrendChart v-if="trend" :telemetries="telemetries" :loading="loading" :colorSet="colorSet" :mode="chartMode"
            :predictionClassColor="predictionClassColor" :predictions="predictions" :style="chartMode"
            :showComments="showComments" :markerSet="markerSet" :trend="trend" :dateRange="dateRange"
            :hideGoTo="hideGoTo" @goMeasurement="goMeasurement">
          </TrendChart>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <br />
          <el-tag :color="chartMode == 'predictions' ? 'white' : colorSet[i]" size="small" :style="{
            'border-color': chartMode == 'predictions' ? '#888888' : colorSet[i],
            color: smartColor(colorSet[i]),
            marginLeft: '5px',
          }" v-for="(f, i) in filters" :key="`${f.telemetry}_${f.telemetrySource}`" closable @close="removeFilter(f)">
            <span style="font-size:16px" v-if="chartMode == 'predictions'">{{ characterMarkerMap[markerSet[i]] }}</span>
            {{ $t('duck.' + f.telemetry) }}
            <span v-if="sourceCount(f.telemetry) > 1 && f.telemetry != f.trendTelemetrySource"> {{ '( '+$t('duck.'+f.telemetrySource)+' ) '
            }}</span>
            <span v-if="f.min !== undefined"> min:{{ f.min }} </span>
            <span v-if="f.max !== undefined"> max:{{ f.max }} </span>
          </el-tag>
          <br>
          <span v-if="aiModel && aiModel.classes">
            <el-tag :color="predictionClassColor[0]" :style="{
              'border-color': chartMode == 'predictions' ? '#888888' : predictionClassColor[0],
              color: smartColor(predictionClassColor[0]),
              marginLeft: '5px',
              marginTop: '15px',
            }">
              No class
            </el-tag>
            <el-tag :color="predictionClassColor[i + 1]" :style="{
              'border-color': chartMode == 'predictions' ? '#888888' : predictionClassColor[i + 1],
              color: smartColor(predictionClassColor[i + 1]),
              marginLeft: '5px',
              marginTop: '15px',
            }" v-for="(c, i) of Object.keys(aiModel.classes)" v-bind:key="c">
              {{ aiModel.classes[c] }}
            </el-tag>
          </span>
          <el-form inline size="mini" label-position="top" style="float: right">
            <el-form-item label="comments">
              <el-checkbox v-model="showComments" size="mini" />
            </el-form-item>
            <el-form-item label="chart mode">
              <el-select v-model="chartMode" size="mini">
                <el-option :value="'lines+markers'" />
                <el-option :value="'markers'" />
                <el-option :value="'predictions'" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="chartMode == 'predictions'" label="AI Model">
              <el-select v-model="aiModelId" size="mini" @change="loadPredictions">
                <el-option v-for="model in aiModels" v-bind:key="model._id" :label="model.name" :value="model._id" />
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-form class="elForm" inline label-position="top" label-width="100px" size="small">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('common.telemetry')">
              <el-select v-model="trendTelemetry" @change="onTelemetryChange" filterable
                :placeholder="$t('common.select')" default-first-option>
                <el-option v-for="item in telemetrySelect" :label="`${$t('duck.' + item.name)}`" v-bind:key="item.name" y
                  :value="item.name"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('common.trendTelemetrySource')" v-show="telemetrySourceSelect.length > 1">
              <el-select v-model="trendTelemetrySource" filterable :placeholder="$t('common.select')"
                default-first-option>
                <el-option v-for="item in telemetrySourceSelect" :label="`${$t('duck.' + item.label)}`" :key="item.key"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

         
            <el-form-item>
              <span slot="label">min <el-switch v-model="isMinActive"></el-switch></span>
              <el-input-number :disabled="!isMinActive" :precision="4" :controls="false" v-model="trendMin"
                @click="addFilter()"></el-input-number>
            </el-form-item>
            <el-form-item>
              <span slot="label">max <el-switch v-model="isMaxActive"></el-switch></span>

              <el-input-number :disabled="!isMaxActive" :precision="4" :controls="false" v-model="trendMax"
                @click="addFilter()">
              </el-input-number>
            </el-form-item>

            <el-form-item style="margin-top: 40px">
              <el-button @click="addFilter()">{{
                  $t("point.addTelemetryToTrend")
              }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="!loading && !hasMeasurement"
      style="flex: 1 1 0%;    height: 250px;    display: flex;    flex-direction: row;    justify-content: center;    align-items: center;    font-style: italic;">
      {{ $t("trend.no_measurement") }}


    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapActions, mapState } from "vuex";
import TrendChart from "./TrendChart";
import { treeHelper } from "../util";
import axios from "axios";
import preferences from "../util/preferences";

export default {
  name: "Form_Trend",
  components: { TrendChart },
  async created() {
    await this.getTelemetrySources();
    let resp = await axios.get(`${process.env.VUE_APP_APIURL}/ai-model`);
    this.aiModels = resp.data.models;

    if (this.trendCache.dateRange && this.trendCache.dateRange.length) {
      this.dateRange = this.trendCache.dateRange;
    } else {
      let d = new Date();
      const end = new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        23,
        59,
        59
      );
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.dateRange = [start, end];

    }
    this.loadTelemetries();

  },
  props: {
    alarms: Array,
    point: {
      type: String,
    },
    hideGoTo: {
      type: Boolean,
      default: false,
    },
  },
  events: ["goMeasurement"],
  data() {
    return {
      measurementTypes: ['PERIODIC', 'TRIGGERED', 'MANUAL'],
      aiModelId: "",
      aiModels: [],
      measurementTypes: ['PERIODIC', 'MANUAL', 'TRIGGERED'],
      measurementType: null,
      aiModel: "",
      multiSource: false,
      filters: [],
      predictions: [],
      hasMeasurement: true,
      chartMode: "lines+markers",
      isMinActive: false,
      isMaxActive: false,
      annotationIndex: -1,
      measurementUrl: "",
      showComments: true,
      get trendTelemetry() {
        return localStorage.getItem("trendTelemetry");
      },
      set trendTelemetry(value) {
        localStorage.setItem('trendTelemetry', value);
      },
      trendTelemetrySource: "",
      trendMeasurementType: "",
      trendMin: "",
      trendMax: "",
      dateRange: [],
      telemetries: [],
      predictionClassColor: [
        "#dddddd",
        "#2326eb",
        "#27e834",
        "#f0e32b",
        "#f0a82b",
        "#e630e2",
        "#30e6d3",
      ],
      markerSet: ["circle", "diamond", "triangle-up", "star"],
      characterMarkerMap: {
        circle: "●",
        diamond: "♦",
        "triangle-up": "▲",
        star: "★",
      },
      infoVisibility: false,
      herustic_filter: true,
      isEmpty: true,
      noMeasurementFound: false,
      colorSet: ["#F1A935", "#3E87A5", "#6EBE9F", "#C94A58", "#55596A"],
      pickerOptions: {
        format: preferences()
          .localization.dateFormat.replace(/D/g, "d") //element ui date format require lowercase
          .replace(/Y/g, "y"),
        shortcuts: [
          {
            text: this.$t("measurement.lastWeek"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("measurement.lastMonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("measurement.lastthreeMonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("measurement.lastyear"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7 * 52);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },

  computed: {
    ...mapState("account", ["activeTab"]),
    ...mapState("tree", ["selectedNode","flatTree"]),
    ...mapState("admin", ["telemetrySources"]),
    ...mapState("trend", ["trendCache", "trend", "loading"]),

    telemetrySelect() {
      return [
        ...new Set(
          this.telemetries
            .filter((x) => x.telemetry.hidden == false && !x.telemetry.calculated)
            .map((x) => {
              return {
                name: x.telemetry.name,
                displayName: x.telemetry.displayName,
                signal: x.telemetry.signal,
              };
            })
        ),
      ];
    },

    path: function () {
      if (this.point) {
        return treeHelper.pointIdToPath(this.flatTree,this.point);
      } else return "";
    },
    telemetrySourceSelect() {
      let telemetry = this.telemetries.find(x => x.telemetry.name == this.trendTelemetry);
      if (!telemetry) {
        return [];
      }
      let sources = telemetry.telemetrySources;
      if (sources.length) {
        return sources.map(x => {
          return {
            label: x.code,
            key: x.code,
            value: x.code
          };
        });
      } else {
        return [{
          label: "unknown",
          key: "unknown",
          value: "unknown"
        }];

      }
    }
  },
  methods: {
    sourceCount(telemetry) {
      let t = this.telemetries.find(x => x.telemetry.name == telemetry);
      if (!t) {
        return 0;
      }
      return t.telemetrySources.length;
    },
    async loadPredictions() {
      this.aiModel = this.aiModels.find(x => x._id == this.aiModelId);
      let resp = await axios.get(
        `${process.env.VUE_APP_APIURL}/ai-model/${this.aiModelId}/predictions`,
        {
          params: {
            point: this.point,
          },
        }
      );
      this.predictions = resp.data;
    },

    onTelemetryChange() {
      let source = this.telemetrySources.find(x => x.telemetry == this.trendTelemetry);
      this.trendTelemetrySource = source.code;
    },
    ...mapActions("trend", ["getTrend"]),
    ...mapActions("admin", ["getTelemetry", "getTelemetrySources"]),
    ...mapActions("tree", ["updateConfig"]),
    smartColor(bgColor, lightColor, darkColor) {
      lightColor = lightColor || "#ffffff";
      darkColor = darkColor || "#000000";
      var color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
      var r = parseInt(color.substring(0, 2), 16); // hexToR
      var g = parseInt(color.substring(2, 4), 16); // hexToG
      var b = parseInt(color.substring(4, 6), 16); // hexToB
      var uicolors = [r / 255, g / 255, b / 255];
      var c = uicolors.map((col) => {
        if (col <= 0.03928) {
          return col / 12.92;
        }
        return Math.pow((col + 0.055) / 1.055, 2.4);
      });
      var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
      return L > 0.179 ? darkColor : lightColor;
    },
    addFilter(skipLoad) {
      let f = this.filters.find(
        (x) => x.telemetry == this.trendTelemetry && x.telemetrySource == this.trendTelemetrySource
      );
      if (!f) {
        let filter = {
          telemetry: this.trendTelemetry,
          telemetrySource: this.trendTelemetrySource,
        };
        if (this.isMinActive) {
          filter.min = this.trendMin;
        }
        if (this.isMaxActive) {
          filter.max = this.trendMax;
        }

        this.filters.push(filter);
      } else {
        this.removeFilter(f, true);
        this.addFilter();
      }
      if (!skipLoad) {
        this.init();
      }
    },
    removeFilter(f, skipLoad) {
      let i = this.filters.findIndex(
        (x) => x.telemetry == f.telemetry && x.telemetrySource == f.telemetrySource
      );
      if (i != -1) {
        this.filters.splice(i, 1);
      }
      if (!skipLoad) {
        this.init();
      }
    },
    async loadTelemetries() {
      let resp = await axios.get(`${process.env.VUE_APP_APIURL}/point/${this.point}/trend/telemetries`);
      if (resp.data.telemetries.length) {
        this.hasMeasurement = true;
        this.telemetries = resp.data.telemetries;
        let defaultTelemetry=this.telemetries.find(x=>x.telemetry.name=="VRMS_ISO10816_OVERALL")

        if(!defaultTelemetry){defaultTelemetry=this.telemetries[0]}

        this.trendTelemetry = defaultTelemetry.telemetry.name;
        
        if (defaultTelemetry.telemetrySources.length) {
          this.trendTelemetrySource = defaultTelemetry.telemetrySources[0].code;

        } else {
          this.trendTelemetrySource = "unknown";
        }
        this.addFilter(false);
      } else {
        this.hasMeasurement = false;
      }


    },
    async init() {
      this.getTrend({
        pointId: this.point,
        dateRange: this.dateRange,
        filters: this.filters,
        measurementType: this.measurementType
      });


      if (this.chartMode == "predictions") {
        this.loadPredictions();
      }
    },
    goMeasurement(measurementId) {
      this.$emit("goMeasurement", measurementId);
    },
  },
  watch: {
    activeTab(c) {
      if (c == "trend") {
        this.updateConfig({
          showCheckbox: false,
        });

      }
    },
  },
};
</script>

<style scoped>
.apexChartClass {
  display: block;
  z-index: 10000;
}

.refreshButton {
  float: right;
  margin: 10px;
  margin-top: 0px;
  padding: 10px;
}

.toolbox {
  float: left;
}

.list {
  display: flex;
  flex-flow: row wrap;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.el-icon-info {
  margin-left: 30px;
}

.trend-tab {
  min-height: 400px;
  max-height: auto;
  flex-direction: column;
  flex: 1;
  display: flex;
  overflow: auto;
}
</style>